"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnableGuestWebResult = void 0;
var EnableGuestWebResult;
(function (EnableGuestWebResult) {
    EnableGuestWebResult["successful"] = "successful";
    EnableGuestWebResult["tokenInvalid"] = "tokenInvalid";
})(EnableGuestWebResult || (exports.EnableGuestWebResult = EnableGuestWebResult = {}));
//# sourceMappingURL=EnableGuestWebResult.js.map